module.exports = __webpack_public_path__ + "img/icon_warning_secondary.4232e284.png";